import {
  getTeamLabelByNumber,
  getDefaultStatisticItem
} from '../../utils/utils'
import { numberFilter } from '../../../../../utils/filters'
import {
  isFiveSets1x1, statisticSchemeFiveSets1x1,
  updateStatisticFiveSets1x1
} from '@/components/pages/TraderMode/sports/padel-tennis/statisticFiveSets1x1'

const statData = {
  firstSirvesWithoutReties: {
    home: 0,
    away: 0
  },
  successfulFirstServes: {
    home: 0,
    away: 0
  },
  secondServesWithoutReties: {
    home: 0,
    away: 0
  },
  successfulSecondServes: {
    home: 0,
    away: 0
  },
  lastEvent: {
    event: '',
    team: ''
  },
  serve: 0,
  breaksCancelEventIds: {
    1: [],
    2: []
  }
}

export default {
  statisticScheme: {
    'UNFORCED_ERROR': getDefaultStatisticItem('statistic.tennis.unforced.error'),
    'SUCCESSFUL_FIRST_SERVES': getDefaultStatisticItem('statistic.successServe', { addPercentSign: true }),
    'SUCCESSFUL_SECOND_SERVES': getDefaultStatisticItem('statistic.successSecondServe', { addPercentSign: true }),
    'BREAKS': getDefaultStatisticItem('statistic.breaks', { inPercents: true }),
    'FIRST_SERVE': getDefaultStatisticItem(),
    'SECOND_SERVE': getDefaultStatisticItem(),
    'SERVE_RETRY': getDefaultStatisticItem(),
    ...statisticSchemeFiveSets1x1.statisticScheme
  },
  statisticEvents: {
    'FIRST_SERVE': 'FIRST_SERVE',
    'SERVE_RETRY': 'SERVE_RETRY',
    'UNFORCED_ERROR': 'UNFORCED_ERROR',
    ...statisticSchemeFiveSets1x1.statisticEvents
  },
  statisticOrder: [
    'SUCCESSFUL_FIRST_SERVES',
    'BREAKS',
    ...statisticSchemeFiveSets1x1.statisticOrder
  ],
  statisticFunction (event, relatedEvent) {
    getFirstServesStatistic.bind(this)(event)
    getSecondServesStatistic.bind(this)(event)
    getBreakStatistic.bind(this)(event)

    if (isFiveSets1x1) {
      updateStatisticFiveSets1x1.bind(this)(event, relatedEvent)
    }
  }
}

function getFirstServesStatistic (event) {
  const { EventCode, TeamNumber, GamePeriod: period } = event

  if (!['CANCEL', 'SERVE_RETRY', 'FIRST_SERVE', 'SECOND_SERVE', 'POINT', 'BALL_IN_GAME', 'SERVE_FAULT'].includes(EventCode)) {
    return
  }

  let needToUpdate = false

  const team = getTeamLabelByNumber(TeamNumber)

  if (
    statData.lastEvent.team === TeamNumber &&
    statData.lastEvent.event === 'FIRST_SERVE' &&
    EventCode !== 'SERVE_RETRY'
  ) {
    needToUpdate = true
    statData.firstSirvesWithoutReties[team]++
  }

  if (
    statData.lastEvent.team === TeamNumber &&
    statData.lastEvent.event === 'FIRST_SERVE' &&
    !['CANCEL', 'SERVE_FAULT', 'SERVE_RETRY'].includes(EventCode)
  ) {
    needToUpdate = true
    statData.successfulFirstServes[team]++
  }

  if (needToUpdate) {
    this.updateStatistic({
      statisticType: 'defaultStatistic',
      property: 'SUCCESSFUL_FIRST_SERVES',
      period,
      team,
      value: getSuccessfulFirstServeValue(statData.successfulFirstServes[team], statData.firstSirvesWithoutReties[team])
    })
  }

  statData.lastEvent.event = EventCode
  statData.lastEvent.team = TeamNumber
}

function getSecondServesStatistic (event) {
  const { EventCode, TeamNumber, GamePeriod: period } = event

  if (!['CANCEL', 'SERVE_RETRY', 'FIRST_SERVE', 'SECOND_SERVE', 'POINT', 'BALL_IN_GAME', 'SERVE_FAULT'].includes(EventCode)) {
    return
  }

  let needToUpdate = false

  const team = getTeamLabelByNumber(TeamNumber)

  if (
    statData.lastEvent.team === TeamNumber &&
    statData.lastEvent.event === 'SECOND_SERVE' &&
    EventCode !== 'SERVE_RETRY'
  ) {
    needToUpdate = true
    statData.secondServesWithoutReties[team]++
  }

  if (
    statData.lastEvent.team === TeamNumber &&
    statData.lastEvent.event === 'SECOND_SERVE' &&
    !['CANCEL', 'SERVE_FAULT', 'SERVE_RETRY'].includes(EventCode)
  ) {
    needToUpdate = true
    statData.successfulSecondServes[team]++
  }

  if (needToUpdate) {
    this.updateStatistic({
      statisticType: 'defaultStatistic',
      property: 'SUCCESSFUL_SECOND_SERVES',
      period,
      team,
      value: getSuccessfulFirstServeValue(statData.successfulSecondServes[team], statData.secondServesWithoutReties[team])
    })
  }

  statData.lastEvent.event = EventCode
  statData.lastEvent.team = TeamNumber
}

function getBreakStatistic (event) {
  const { EventCode, TeamNumber, GamePeriod: period, EventNumber, RelatedEventNumber } = event

  if (!TeamNumber && EventCode !== 'CANCEL') return

  const team = getTeamLabelByNumber(TeamNumber)

  switch (EventCode) {
    case 'FIRST_SERVE':
      statData.serve = TeamNumber

      break

    case 'CANCEL':
      if (statData.breaksCancelEventIds[1].includes(RelatedEventNumber)) {
        this.updateStatistic({
          statisticType: 'defaultStatistic',
          property: 'BREAKS',
          period,
          team: getTeamLabelByNumber(1),
          type: 'decrement'
        })
      }

      if (statData.breaksCancelEventIds[2].includes(RelatedEventNumber)) {
        this.updateStatistic({
          statisticType: 'defaultStatistic',
          property: 'BREAKS',
          period,
          team: getTeamLabelByNumber(2),
          type: 'decrement'
        })
      }

      break
    case 'GAME':
      if (
        statData.serve === 1 &&
        TeamNumber === 2
      ) {
        this.updateStatistic({
          statisticType: 'defaultStatistic',
          property: 'BREAKS',
          period,
          team,
          type: 'increment'
        })

        statData.breaksCancelEventIds[2].push(EventNumber)

        break
      }

      if (
        statData.serve === 2 &&
        TeamNumber === 1
      ) {
        this.updateStatistic({
          statisticType: 'defaultStatistic',
          property: 'BREAKS',
          period,
          team,
          type: 'increment'
        })

        statData.breaksCancelEventIds[1].push(EventNumber)

        break
      }
  }
}

const getSuccessfulFirstServeValue = (successfulFirstServes, firstServes) => {
  return Number(numberFilter(successfulFirstServes / firstServes * 100, 0))
}
